import firebase from 'firebase/app';
import 'firebase/auth';

// import FBSDK from 'react-native-fbsdk';

import { IS_WEB, QUICK_PASSWORD } from './appConstants';

import { fetch } from '../utils/appUtils';

import { WarriorType } from './types';
import { getWarriorByLogin } from './dbCalls';

declare var FB: any;

async function signInFB(): Promise<any> {
  let result;
  if (IS_WEB) {
    result = await new Promise<any>((resolve) => {
      FB.login(
        (response: any) => {
          const rresult = response;
          if (!response.authResponse) rresult.isCancelled = true;
          else rresult.accessToken = response.authResponse.accessToken;
          resolve(rresult);
        },
        { scope: 'public_profile, email' },
      );
    });
  } else {
    // result = await FBSDK.LoginManager.logInWithPermissions(['public_profile', 'email']);
  }
  return result;
}

async function fetchAccessTokenFB() {
  // const result = await FBSDK.AccessToken.getCurrentAccessToken();
  // return result;
  return null;
}

export async function getIdToken(refresh?: boolean) {
  const result = await firebase.auth().currentUser!.getIdToken(refresh);
  return result;
}

export async function signInAndFetchDataFB() {
  const fbUser = await signInFB();
  if (fbUser.isCancelled) return null;
  if (!fbUser.accessToken) {
    fbUser.accessToken = await fetchAccessTokenFB();
  }

  const { accessToken } = fbUser;

  const fbCredential = firebase.auth.FacebookAuthProvider.credential(accessToken);

  const fbSignIn = await firebase.auth().signInAndRetrieveDataWithCredential(fbCredential);
  const { user } = fbSignIn as any;
  user.accessToken = accessToken;
  user.idToken = await getIdToken();
  return user;
}

export async function signIn(email: string, password: string) {
  const result: any = await new Promise((resolve, reject) => {
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)

      .then(resolve)
      .catch(reject);
  });
  const { user } = result;
  user.idToken = await getIdToken();
  return user;
}

export function authCheck(): Promise<any> {
  return new Promise((resolve, reject) => {
    firebase.auth().onAuthStateChanged(async (user: any) => {
      if (user) {
        user.idToken = await getIdToken();
        resolve(user);
      } else {
        reject();
      }
    });
  });
}

export async function uniqLogin(login: string): Promise<WarriorType | null> {
  return getWarriorByLogin(login) as Promise<WarriorType | null>;
}

async function signUpEmail(_email?: string) {
  // TODO: temporary solution later service should be checked
  try {
    // await fetch('/signUpEmail', { email });
  } catch (e) {} // eslint-disable-line
}

export async function signUp(email: string, password: string) {
  const result = await firebase.auth().createUserWithEmailAndPassword(email, password);
  signUpEmail(email);
  return result;
}

export async function resetPassword(email: string) {
  await firebase.auth().sendPasswordResetEmail(email);
}

export async function signOut() {
  await firebase.auth().signOut();
}

export async function updateEmail(user: any, email: string) {
  await user.updateEmail(email);
}

export async function updatePassword(user: any, password: string) {
  await user.updatePassword(password);
}

export async function checkOldPassword(email: string, password: string): Promise<boolean> {
  try {
    await firebase
      .auth()

      .currentUser!.reauthenticateAndRetrieveDataWithCredential(
        firebase.auth.EmailAuthProvider.credential(email, password),
      );
  } catch (e) {
    return false;
  }

  return true;
}

export async function signUpQuick(user: any, email: string, password: string, { login }: any) {
  const cred = firebase.auth.EmailAuthProvider.credential(user.email, QUICK_PASSWORD);
  await user.reauthenticateAndRetrieveDataWithCredential(cred);

  await updateEmail(user, email);
  await updatePassword(user, password);

  await fetch('/changeQuickWarrior', { login });

  signUpEmail(email);
}

export async function signUpQuickFB(user: any, { login }: any) {
  const fbUser = await signInFB();
  if (fbUser.isCancelled) return false;
  if (!fbUser.accessToken) {
    fbUser.accessToken = await fetchAccessTokenFB();
  }

  const { accessToken } = fbUser;

  const fbCredential = firebase.auth.FacebookAuthProvider.credential(accessToken);
  await user.linkAndRetrieveDataWithCredential(fbCredential);

  await user.unlink(user.providerData[1].providerId);

  const { email } = user.providerData[0];
  await updateEmail(user, email);

  await fetch('/changeQuickWarrior', { login });

  return undefined;
}
